import {headers} from '../common'

async function getListUserContact(params) {

  const queryParams = new URLSearchParams(params);

  return fetch('/api/contacts/user?' + queryParams)
        .then(res => {
          return res;
        })
        .catch(errors => {
          return errors;
        })
}

async function getListPartnerContact(params) {

  const queryParams = new URLSearchParams(params);

  return fetch('/api/contacts/partner?' + queryParams)
        .then(res => {
          return res;
        })
        .catch(errors => {
          return errors;
        })
}

async function getListOtherUserContact(params) {

  const queryParams = new URLSearchParams(params);

  return fetch('/api/contacts/other?' + queryParams)
        .then(res => {
          return res;
        })
        .catch(errors => {
          return errors;
        })
}

async function sendMessage(api, message) {
  return fetch(api, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ message: message }),
  }).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

async function getListMessage(api) {
  return fetch(api)
        .then(res => {
          return res;
        })
        .catch(errors => {
          return errors;
        });
}

async function resolveContact(api) {
  return fetch(api, {
    method: 'POST',
    headers: headers,
  }).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

async function unresolveContact(api) {
  return fetch(api, {
    method: 'POST',
    headers: headers,
  }).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

async function resendCode(partnerResetCode, role) {
  const url = role == 3 ? `/my-page/change-mail/resend` : `/staff/${partnerResetCode.staff_id}/change-mail/resend?mail=${partnerResetCode.mail_address}`
  return fetch(url, {
    method: 'POST',
    headers: headers,
  }).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

export {
  getListUserContact,
  getListPartnerContact,
  getListOtherUserContact,
  getListMessage,
  sendMessage,
  resolveContact,
  unresolveContact,
  resendCode,
}
